import { render, staticRenderFns } from "./BackstageSetting.vue?vue&type=template&id=98fab52c&scoped=true"
import script from "./BackstageSetting.vue?vue&type=script&lang=js"
export * from "./BackstageSetting.vue?vue&type=script&lang=js"
import style0 from "./BackstageSetting.vue?vue&type=style&index=0&id=98fab52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fab52c",
  null
  
)

export default component.exports